import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import Kpi from "components/Kpi";

// Tightened from `PropTypes.object`: parent (PaychexDashboard.getKpiData)
// produces these four numeric fields; each is passed to Kpi's value
// (string | number).
interface KpiData {
  rolloverCount: number;
  averageSize: number;
  totalRolloverAmount: number;
  aumTotal: number;
}

interface Props {
  kpiData: KpiData;
}

const PaychexKpis = ({ kpiData }: Props) => {
  return (
    <>
      <Row className="mb-4">
        <Col md={6}>
          <Card className="h-100">
            <Card.Body>
              <Kpi label="Rollover Count" value={kpiData.rolloverCount} />
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="h-100">
            <Card.Body>
              <Kpi
                label="Average Size"
                value={kpiData.averageSize}
                format="currency"
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row className="mb-4">
        <Col md={6}>
          <Card className="h-100">
            <Card.Body>
              <Kpi
                label="Total Rollover Amount"
                value={kpiData.totalRolloverAmount}
                format="currency"
              />
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="h-100">
            <Card.Body>
              <Kpi
                label="AUM Total"
                value={kpiData.aumTotal}
                format={"currency"}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default PaychexKpis;
